import React, { useEffect, useState, useCallback, Fragment } from "react";
import PropTypes from "prop-types";
import RegisterDialog from "./RegisterDialog";
import TermsOfServiceDialog from "./TermsOfServiceDialog";
import LoginDialog from "./LoginDialog";
import ChangePasswordDialog from "./ChangePasswordDialog";
import ModalBackdrop from "../../../shared/components/ModalBackdrop";
import VerificationCodeDialog from "./VerificationCodeDialog";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function DialogSelector(props) {
  const {
    dialogOpen,
    openTermsDialog,
    openRegisterDialog,
    openLoginDialog,
    openChangePasswordDialog,
    openVerificationCodeDialog,
    onClose,
  } = props;
  const [loginStatus, setLoginStatus] = useState(null);
  const [cognitoUser, setCognitoUser] = useState({});
  const [registerStatus, setRegisterStatus] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const _onClose = useCallback(() => {
    setLoginStatus(null);
    setVerificationStatus(null);
    setRegisterStatus(null);
    onClose();
  }, [onClose, setLoginStatus, setVerificationStatus,setRegisterStatus]);

  const printDialog = useCallback(() => {
    switch (dialogOpen) {
      case "register":
        return (
          <RegisterDialog
            onClose={_onClose}
            openTermsDialog={openTermsDialog}
            status={registerStatus}
            openLoginDialog={openLoginDialog}
            loginStatus={loginStatus}
            setLoginStatus={setLoginStatus}
            setStatus={setRegisterStatus}
            windowDimensions={windowDimensions}
            setWindowDimensions={setWindowDimensions}
          />
        );
      case "termsOfService":
        return <TermsOfServiceDialog onClose={openRegisterDialog} />;
      case "login":
        return (
          <LoginDialog
            onClose={_onClose}
            status={loginStatus}
            setStatus={setLoginStatus}
            openChangePasswordDialog={openChangePasswordDialog}
            cognitoUser={cognitoUser}
            setCognitoUser={setCognitoUser}
          />
        );
      case "changePassword":
        return (
          <ChangePasswordDialog
            setLoginStatus={setLoginStatus}
            onClose={openLoginDialog}
            openVerificationCodeDialog={openVerificationCodeDialog}
          />
        );
        case "verificationCode":
          return (
            <VerificationCodeDialog
              setLoginStatus={setLoginStatus}
              onClose={openLoginDialog}
              openLoginDialog={openLoginDialog}
              setStatus={setVerificationStatus}

            />
          );
      default:
    }
  }, [
    dialogOpen,
    openChangePasswordDialog,
    openVerificationCodeDialog,
    openLoginDialog,
    openRegisterDialog,
    openTermsDialog,
    _onClose,
    loginStatus,
    registerStatus,
    setLoginStatus,
    setRegisterStatus,
    cognitoUser,
    setCognitoUser,
  ]);

  return (
    <Fragment>
      {dialogOpen && <ModalBackdrop open />}
      {printDialog()}
    </Fragment>
  );
}

DialogSelector.propTypes = {
  dialogOpen: PropTypes.string,
  openLoginDialog: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  openTermsDialog: PropTypes.func.isRequired,
  openRegisterDialog: PropTypes.func.isRequired,
  openChangePasswordDialog: PropTypes.func.isRequired,
};

export default DialogSelector;
